export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-greek-400-normal.woff2?a8de720a6f13c66c8a4e8429d01a93c8";